@if (chartId) {
  <div class="container common-container-padding">
    <div
      class="pie-chart-title"
      [ngClass]="isMobile ? 'pie-chart-title-horizontal-padding' : ''"
    >
      Portfolio Mix by GWP
    </div>
    <!-- TOOLTIP -->
    <div id="pie-tooltip" class="pie-tooltip"></div>
    <!-- CHART-->
    <div nxRow>
      @if (isMobile) {
        <div class="pie-and-tooltip" nxCol="12">
          <div class="mobile-pie-chart-container">
            <canvas [id]="chartId" class="pie-chart"></canvas>
          </div>
        </div>
      }
      @if (!isMobile) {
        <div class="pie-and-tooltip" nxCol="12,12,12,8">
          <div class="pie-chart-container">
            <canvas [id]="chartId" class="pie-chart"></canvas>
          </div>
        </div>
      }
      <!-- LEGEND -->
      @if (!isMobile) {
        <div class="pie-legend-container" nxCol="12,12,12,4">
          <div id="pie-legend"></div>
        </div>
      }
      @if (isMobile) {
        <div class="pie-legend-container" nxCol="12">
          <div id="pie-legend"></div>
        </div>
      }
    </div>
    <div class="bottom-text labelFont" id="bottom-text">
      {{ currentYear }}: RM {{ currentYearTotal }}K
    </div>
  </div>
}
